import { component } from "picoapp";
import $ from "jquery";

export default component((node) => {
  const start = $(node).data("startingQuantity");
  let end = $(node).data("currentQuantity");
  const $container = $(".product-loader-container");
  const duration = $(node).data("duration") || 2500;
  const $close = $(".product-loader-close");

  const close = () => {
    $container.addClass("fade");
  };

  $close.on("click touch", function () {
    close();
  });

  if (end > start) {
    setTimeout(() => close(), duration);
    return false;
  }

  if (end <= 0) {
    end = 0;
  }

  setTimeout(function () {
    node.style.transitionDuration = `${duration}ms`;
    node.innerHTML = end;
  }, 500);

  setTimeout(() => close(), duration + 2500);
});
